import { types, successAction } from "@authzsvc/api-lib";

export default (state = [], action) => {
  switch (action.type) {
    case successAction(types.GET_APPLICATION_LIST):
      return [...action.payload.data];
    case successAction(types.GET_ALL_APPLICATIONS):
      return [...action.payload.data];
    case successAction(types.ADD_APPLICATION):
      return [...state, action.payload.data];
    case successAction(types.DELETE_APPLICATION):
      return state.filter((app) => app.id !== action.payload.data.id);
    default:
      return state;
  }
};
